import { render, staticRenderFns } from "./DeleteXSS.vue?vue&type=template&id=f8dfac48&"
import script from "./DeleteXSS.vue?vue&type=script&lang=js&"
export * from "./DeleteXSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports